module.exports = __webpack_public_path__ + "static/assets/1505a7fe5cdea368a3e32622c3e334f1.svg";